import { Avatar, Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';

const UserItem = ({ item, onClick }) => {
  return (
    <Clickable onClick={onClick}>
      <Row>
        <Avatar user={item} />
        <Col center marg="0 0 0 12px" gap="2px">
          <Text bold>{item.name}</Text>
          {!!item.bio?.length && (
            <Text b2 col={theme.GREY_60}>
              {item?.bio}
            </Text>
          )}
        </Col>
      </Row>
    </Clickable>
  );
};

export default UserItem;
